import React, { useEffect } from "react";
import { init } from "api/init";
import { sendOrder } from "api/product";
import { Container } from "react-bootstrap";
import Loading from "components/loading";
import List from "./components/carsList";
import Detial from "./components/carDetial";
import Option from "./components/option";
import Form from "./components/form";
import Dealer from "./components/dealer";
import Confirm from "./components/confirm";
import MainContext from "contexts/main";
import { toast } from "react-toastify";
const Sell = () => {
  const { user } = React.useContext(MainContext);
  const [state, dispatch] = React.useReducer(
    (state, action) => {
      switch (action.type) {
        case "SET_INIT_DATA":
          return {
            ...state,
            initData: action.payload.items,
            // recaptcha: action.payload.recaptcha,
            loading: false,
          };
        case "SET_STEP":
          return { ...state, step: action.payload };
        case "SET_SELECTED":
          return {
            ...state,
            selected: action.payload,
            gateways: action.payload.gateways,
            selectedGeteway: action.payload.gateways[0]
                ? action.payload.gateways[0]
                : null,
            step: "detial",
            selectedOptions: {},
            selectedDealer: null,
          };
        case "SET_SELECTED_DEALER":
          return { ...state, selectedDealer: action.payload };
        case "SET_SELECTED_OPTION":
          return {
            ...state,
            selectedOptions: { ...state.selectedOptions, ...action.payload },
          };
        case "TOGGLE_LOADING":
          return { ...state, loading: !state.loading };
        case "SET_PROFILE":
          return {
            ...state,
            profile: action.payload,
            loading: false,
            step: "dealer",
          };
        case "SUBMIT_LOADING":
          return { ...state, submitingLoading: action.payload };
        case "SET_SHOW_PIC":
          return { ...state, showPic: action.payload };
        case "SET_SELECTED_GETEWAY":
          return { ...state, selectedGeteway: action.payload };
        default:
          return state;
      }
    },
    {
      initData: null,
      recaptcha: null,
      gateways: [],
      selectedGeteway: null,
      loading: true,
      step: "list",
      selected: null,
      profile: null,
      selectedOptions: {},
      selectedDealer: null,
      submitingLoading: false,
      showPic: "213",
    }
  );
  useEffect(() => {
    const fetchData = async () => {
      await init()
        .then((res) => {
          dispatch({
            type: "SET_INIT_DATA",
            payload: {
              items: res.data.items,
              // recaptcha: res.data.recaptcha,
              gateways: res.data.gateways,
            },
          });
        })
        .catch((err) => {
          dispatch({ type: "TOGGLE_LOADING" });
        });
    };
    fetchData();
  }, []);
  const submit = async (captcha) => {
    dispatch({ type: "SUBMIT_LOADING", payload: true });
    const data = {};
    Object.keys(state.selectedOptions).forEach((key) => {
      data[key] = state.selectedOptions[key].id;
    });
    data.dealer_id = state.selectedDealer.id;
    // data["g-recaptcha-response"] = captcha;
    data.accepted = 1;
    data.gateway = state.selectedGeteway;
    sendOrder(state.selected.id, data)
      .then((res) => {
        dispatch({ type: "SUBMIT_LOADING", payload: false });
        window.location.replace(res.data.url);
      })
      .catch((err) => {
        dispatch({ type: "SUBMIT_LOADING", payload: false });
        if (err.response.status === 423) {
          toast.warning("سرور مشغول است دوباره تلاش کنید");
        }
      });
  };
  const stepView = () => {
    let data = state?.initData;
    switch (state.step) {
      case "list":
        return (
          <List
            items={data}
            select={(item) => dispatch({ type: "SET_SELECTED", payload: item })}
            showPic={state.showPic}
          />
        );
      case "detial":
        return (
          <Detial
            item={state.selected}
            prev={() => dispatch({ type: "SET_STEP", payload: "list" })}
            next={() => dispatch({ type: "SET_STEP", payload: "option" })}
            showPic={state.showPic}
          />
        );
      case "option":
        return (
          <Option
            product={state.selected}
            selectedOptions={state.selectedOptions}
            prev={() => dispatch({ type: "SET_STEP", payload: "detial" })}
            next={() => {
              let nextStep = "form";
              if (user?.profile.has_profile) {
                nextStep = "dealer";
              }
              dispatch({ type: "SET_STEP", payload: nextStep });
            }}
            selectOption={(option) => {
              dispatch({ type: "SET_SELECTED_OPTION", payload: option });
            }}
            changeImage={(refrence) => {
              dispatch({ type: "SET_SHOW_PIC", payload: refrence });
            }}
            showPic={state.showPic}
          />
        );
      case "form":
        return (
          <Form
            product={state.selected}
            selectedOptions={state.selectedOptions}
            prev={() => dispatch({ type: "SET_STEP", payload: "option" })}
            nextStep={() => dispatch({ type: "SET_STEP", payload: "dealer" })}
            showPic={state.showPic}
          />
        );
      case "dealer":
        return (
          <Dealer
            product={state.selected}
            selectedDealer={state.selectedDealer}
            setDealer={(dealer) =>
              dispatch({ type: "SET_SELECTED_DEALER", payload: dealer })
            }
            selectedOptions={state.selectedOptions}
            prev={() => dispatch({ type: "SET_STEP", payload: "form" })}
            next={() => dispatch({ type: "SET_STEP", payload: "confirm" })}
            showPic={state.showPic}
          />
        );
      case "confirm":
        return (
          <Confirm
            product={state.selected}
            selectedDealer={state.selectedDealer}
            selectedOptions={state.selectedOptions}
            recaptcha={state.recaptcha}
            submit={submit}
            loading={state.submitingLoading}
            goTo={(step) => dispatch({ type: "SET_STEP", payload: step })}
            prev={() => dispatch({ type: "SET_STEP", payload: "dealer" })}
            showPic={state.showPic}
            gateways={state.gateways}
            selectedGeteway={state.selectedGeteway}
            setGeteway={(geteway) =>
              dispatch({ type: "SET_SELECTED_GETEWAY", payload: geteway })
            }
          />
        );
      default:
        return (
          <List
            items={data}
            select={(item) => dispatch({ type: "SET_SELECTED", payload: item })}
          />
        );
    }
  };
  if (state.loading) {
    return <Loading />;
  }
  return <Container>{stepView()}</Container>;
};
export default Sell;
